export default __webpack_public_path__ + "media/transfer_window/transfer_error-63101635.png";